import { Navigation } from './Navigation';
import { useResponsive } from '../hooks/useResponsive';

export function SidebarDesktop() {
  const { prefersMobileLayout } = useResponsive();

  if (prefersMobileLayout) {
    return null;
  }

  return (
    <aside
      className='bg-brand-primary fixed top-header-height
        h-[calc(100dvh-var(--spacing-header-height))]
        w-(--spacing-sidebar-width) flex-col overflow-y-auto pt-8 pb-6 flex'
    >
      <Navigation />
    </aside>
  );
}
